export default {
  'companies.searchBar.button': 'Criar Nova Empresa',
  'companies.list.header.name': 'Nome da Empresa',
  'companies.list.header.cnpj': 'CNPJ',
  'companies.list.header.situation': 'Situação',
  'companies.list.header.email': 'e-mail',
  'companies.list.header.phone': 'Telefone',
  'companies.list.header.includedAt': 'Inclusão',
  'companies.list.header.actions': 'Ações',
  'companies.list.column.actions.button': 'Ver/Editar',
  'companies.general.form.name': 'Nome da empresa',
  'companies.general.form.fantasyName': 'Nome Fantasia',
  'companies.general.form.companyType': 'Tipo de Empresa',
  'companies.general.form.companyType.mechanics': 'Mecânica',
  'companies.general.form.companyType.bodyShop': 'Funilaria',
  'companies.general.form.cnae': 'CNAE',
  'companies.general.form.webSite': 'WebSite',
  'companies.general.form.cnpj': 'CNPJ',
  'companies.general.form.municipalRegistration': 'Inscrição Municipal',
  'companies.general.form.stateRegistration': 'Inscrição Estadual',
  'companies.general.form.taxRegime': 'Regime tributário',
  'companies.general.form.occupationArea': 'Área de atuação',
  'companies.general.form.cep': 'CEP',
  'companies.general.form.uf': 'UF',
  'companies.general.form.city': 'Cidade',
  'companies.general.form.district': 'Bairro',
  'companies.general.form.street': 'Logradouro',
  'companies.general.form.number': 'Número',
  'companies.general.form.complement': 'Complemento',
  'companies.general.form.zone': 'Região',
  'companies.general.form.observation': 'Observações',
  'companies.general.form.contacts': 'Contatos',
  'companies.general.form.contacts.value': 'Contato',
  'companies.general.form.contacts.contactType': 'Tipo de Contato',
  'companies.settings.form.stock': 'Estoque',
  'companies.settings.form.stockOptions.ipiPercentage': 'Percentual de IPI',
  'companies.settings.form.stockOptions.replacementValue':
    'Valor de substituição',
  'companies.settings.form.stockOptions.shippingCost': 'Valor de frete',
  'companies.settings.form.stockOptions.valueOfIncidentalExpenses':
    'Valor de despesas acessórias',
  'companies.settings.form.stockOptions.fixedCostPercentual':
    'Percentual de custo fixo',
  'companies.settings.form.fixedCost': 'Custo Fixo %',
  'companies.settings.form.fixedProfitPercentage': 'Percentual de lucro Fixo %',
  'companies.settings.form.stockAuto': 'Dar baixa automática no estoque?',
  'companies.settings.form.budget': 'Orçamento',
  'companies.settings.form.marginRef': '(%) Margem ref.',
  'companies.settings.form.pieceDiscount': '(%) Desconto Peça',
  'companies.settings.form.serviceDiscount': '(%) Desconto Serviço',
  'companies.settings.form.mandatoryKm': 'Campo KM obrigatório',
  'companies.settings.form.prism': 'Campo Prisma obrigatório',
  'companies.settings.form.tankLevel': 'Campo Nível de Tanque obrigatório',
  'companies.settings.form.alwaysGenerateActivityByWorkOrder':
    'Sempre gerar atividade ao criar orçamento',
  'companies.settings.form.isMechanicSheetAutoFill':
    'Preenchimento automático dos itens na folha de mecânica',
  'companies.settings.form.generateFinancial': 'Gerar financeiro',
  'companies.settings.form.withInstallments': 'Com Parcelamento Livre',
  'companies.settings.form.withInstallmentsPaymentConditions':
    'Com parcelamento vinculado à condições de pagamento',
  'companies.settings.form.tokens': 'Tokens',
  'companies.settings.form.tokenCilia':
    'Token de segurança para importações do sistema Cilia',
  'companies.settings.form.tokenAudatexweb':
    'Token de segurança para importações do sistema AudatexWeb',
  'companies.settings.form.pieceCreate': 'Criação por peça no orçamento',
  'companies.settings.form.paintingHourValue': '(R$) Valor/hora pintura',
  'companies.settings.form.paintingArea': 'Área de pintura',
  'companies.settings.form.changeHourValue': '(R$) Valor/hora troca',
  'companies.settings.form.changeArea': 'Área de troca',
  'companies.settings.form.repairHourValue': '(R$) Valor/hora reparação',
  'companies.settings.form.repairArea': 'Área de reparação',
  'companies.settings.form.budgetApi': 'API Orçamentos',
  'companies.settings.form.budgetApiKey': 'Chave',
  'companies.settings.form.boschCheckList': 'Usar check-list bosch?',
  'companies.settings.form.alwaysSendWorkOrdersToMyBcs':
    'Sempre enviar ordens de serviço para MyBCS',
  'companies.settings.form.receiveMyBcsEvents':
    'Sempre receber eventos do MyBCS',

  'companies.create.notification.success': 'Sucesso',
  'companies.create.notification.successDescription': 'Empresa criada.',

  'companies.update': 'Editar Empresa',
  'companies.update.notification.success': 'Sucesso',
  'companies.update.notification.successDescription': 'Empresa atualizada.',

  'companies.customTerm.created.notification.successDescription':
    'Termos Personalizados criado.',
  'companies.customTerm.update.notification.successDescription':
    'Termos Personalizados atualizado.',

  'companies.remove': 'Remover Empresa',
  'companies.remove.alert': 'Você realmente deseja remover a empresa:',
  'companies.remove.notification.success': 'Sucesso',
  'companies.remove.notification.successDescription': 'Empresa removida.',
  'companies.remove.error.delete.constraint':
    'Não é possivel excluir uma empresa que tenha vínculo com outro módulo!',

  'companies.settings.itemTags.entity.company': 'Empresa',
  'companies.settings.itemTags.entity.description': 'Descrição',
  'companies.settings.itemTags.entity.color': 'Cor',

  'companies.settings.itemTags.create': 'Criar Tag de Orçamento',
  'companies.settings.itemTags.create.notification.success': 'Sucesso',
  'companies.settings.itemTags.create.notification.success.description':
    'Tag de orçamento criada.',

  'companies.settings.itemTags.update': 'Atualizar Tag de Orçamento',
  'companies.settings.itemTags.update.notification.success': 'Sucesso',
  'companies.settings.itemTags.update.notification.success.description':
    'Tag de orçamento atualizada.',

  'companies.settings.itemTags.remove': 'Remover Tag de orçamento',
  'companies.settings.itemTags.remove.confirm.title':
    'Remover Tag de orçamento',
  'companies.settings.itemTags.remove.confirm.content':
    'Você realmente deseja remover a tag de orçamento?',
  'companies.settings.itemTags.remove.success.message': 'Sucesso',
  'companies.settings.itemTags.remove.success.description':
    'Tag de orçamento removida.',
  'companies.settings.itemTags.errors.workorder_item_tag_use':
    'Não é possível remover a Tag de orçamento, pois a mesma já possui um vínculo.',

  'companies.settings.priceComposition':
    'Composição de Preços de Peças e Insumos',

  'companies.settings.priceComposition.domain.fixedCost': '(%) Custo fixo',
  'companies.settings.priceComposition.domain.fixedProfitMargin':
    '(%) Percentual de lucro Fixo',

  'companies.settings.priceComposition.domain.enums.item_field_calculate.ipi':
    'Percentual de IPI',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.tax_replacement':
    'Valor de substituição tributária',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.freight':
    'Valor de frete',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.accessory':
    'Outras despesas',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.fixed_cost':
    'Percentual de custo fixo',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.icms':
    'ICMS Desoneração',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.operational':
    'Despesas operacionais',
  'companies.settings.priceComposition.domain.enums.item_field_calculate.profit_margin':
    'Calcular margem de lucro',

  'companies.settings.priceComposition.update.notification.success': 'Sucesso',
  'companies.settings.priceComposition.update.notification.success.description':
    'Composição de Preços atualizada.',

  'companies.customTerms.form.rgpdLabel': 'Termo LGPD',
  'companies.customTerms.form.responsability': 'Termo de Responsabilidade',
  'companies.customTerms.form.rgpdPlaceholder':
    'Insira aqui o Termo de Consentimento valido pelo seu jurídico/contabilidade de sua empresa.',
  'companies.customTerms.form.responsabilityPlaceholder':
    'Digite aqui o conteúdo do termo de responsabilidade',
  'companies.customTerms.form.warrantyLabel': 'Termo de Garantia',
  'companies.customTerms.form.warrantyPlaceholder':
    'Digite aqui o conteúdo do termo de garantia',
  'companies.customTerms.form.stayLabel': 'Declaração de permanência',
  'companies.customTerms.form.stayPlaceholder':
    'Digite aqui o conteúdo da declaração de permanência',
  'companies.customTerms.form.dischargeLabel': 'Termo de quitação',
  'companies.customTerms.form.dischargePlaceholder':
    'Digite aqui o conteúdo do termo de quitação',
  'companies.customTerms.form.signatureLabel': 'Declaração de assinatura da OS',
  'companies.customTerms.form.signaturePlaceHolder':
    'Digite aqui a declaração personalizada da assinatura dos relatórios administrativos da OS.',
  'companies.customTerms.form.partsSuppliedLabel': 'Termo Peças fornecidas',
  'companies.customTerms.form.responsabilityLabel': 'Termo de responsabilidade',
  'companies.customTerms.form.partsSuppliedPlaceholder':
    'Digite aqui o conteúdo do termo de peça fornecida',
  'companies.customTerms.form.plateSealCutTerms':
    'Termo de corte de selo de placa',
  'companies.customTerms.form.plateSealCutTermsPlaceholder':
    'Digite aqui o conteúdo do termo de corte de selo de placa',

  'companies.customTerms.invoice.form.emissionEnvironment': 'Ambiente emissão',
  'companies.customTerms.invoice.form.emissionEnvironment.production':
    'Produção',
  'companies.customTerms.invoice.form.emissionEnvironment.homologation':
    'Homologação',
  'companies.customTerms.invoice.form.noteType': 'Tipo de Nota',
  'companies.customTerms.invoice.form.noteType.issueInvoice':
    'Emitir Nota fiscal',
  'companies.customTerms.invoice.form.noteType.issueConsumerInvoice':
    'Emitir Nota fiscal do consumidor',
  'companies.customTerms.invoice.form.noteType.issueTaxCoupon':
    'Emitir Cupom Fiscal - SAT',
  'companies.customTerms.invoice.form.noteType.issueCombinedInvoice':
    'Emitir Nota Conjugada',
  'companies.customTerms.invoice.form.noteType.typeOfDigitalCertificate':
    'Tipo de Certificado Digital',
  'companies.customTerms.invoice.form.noteType.uploadToSystem':
    'Upload para o sistema',
  'companies.customTerms.invoice.form.noteType.installedOnTheMachine':
    'Instalado na Máquina',
  'companies.customTerms.invoice.form.useUnife': 'Usa Uninfe',
  'companies.customTerms.invoice.form.digitalCertificateA1':
    'Certificado digital A1',

  'companies.customTerms.invoice.form.owner': 'Proprietário ',
  'companies.customTerms.invoice.form.homeValidity': 'Início Validade',
  'companies.customTerms.invoice.form.endValidity': 'Final Validade',
  'companies.customTerms.invoice.form.modal.title':
    'Upload certificado digital',
  'companies.customTerms.invoice.form.info':
    'Marque quais os tipos de nota fiscal a sua empresa emite',
  'companies.customTerms.invoice.form.upload.msg': 'Clique ou arraste',
  'companies.customTerms.invoice.form.certificatePassword':
    'Senha do Certificado',
  'companies.customTerms.invoice.form.email': 'Email',

  'companies.customTerms.invoice.form.field.invoice': 'Nota Fiscal',
  'companies.customTerms.invoice.form.field.invoice.model': 'Modelo',
  'companies.customTerms.invoice.form.field.invoice.series': 'Série',
  'companies.customTerms.invoice.form.field.invoice.cfop': 'CFOP',
  'companies.customTerms.invoice.form.field.invoice.enforceability':
    'Exigibilidade Iss',
  'companies.customTerms.invoice.form.field.invoice.LastGeneratedNFe':
    'Ultima NF-e gerada',
  'companies.customTerms.invoice.form.field.invoice.generateInvoice':
    'Gerar nota fiscal de franquia de peças',
  'companies.customTerms.invoice.form.field.invoice.generateInvoice.info':
    'Quando este campo está marcado, todo orçamento com a franquia maior que o valor de serviço, gera uma nota de franquia de peças',
  'companies.customTerms.invoice.form.field.invoice.generateTag':
    'Gerar tag "infRespTec" no XML da NF-e',
  'companies.customTerms.invoice.form.field.invoice.idCsrt': 'ID CSRT',
  'companies.customTerms.invoice.form.field.invoice.securityCode':
    'Código de Segurança do Responsável Técnico',

  'companies.customTerms.invoice.form.field.invoiceCustomer':
    'Nota Fiscal de Consumidor',
  'companies.customTerms.invoice.form.field.invoiceCustomer.model': 'Modelo',
  'companies.customTerms.invoice.form.field.invoiceCustomer.series': 'Série',
  'companies.customTerms.invoice.form.field.invoiceCustomer.securityCode':
    'Código de segurança',
  'companies.customTerms.invoice.form.field.invoiceCustomer.LastGeneratedNFCe':
    'Ultima NFC-e gerada',
  'companies.customTerms.invoice.form.field.invoiceCustomer.cldToken':
    'cldToken',
  'companies.customTerms.invoice.form.field.invoiceCustomer.sendNFCe':
    'Enviar a NFC-e utilizando o processo síncrono',

  'companies.customTerms.invoice.form.field.issueTaxCoupon': 'Cupom Fiscal SAT',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.version':
    'Versão',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.cashierNumber':
    'Numero do Caixa',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.serialNumber':
    'Número de série',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.activationCode':
    'Codigo ativação',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.subscriptionKey':
    'Chave de assinatura',
  'companies.customTerms.invoice.form.field.invoiceCustomer.issueTaxCoupon.btn.addEquipment':
    'Adicionar Equipamento',

  'companies.customTerms.invoice.form.field.irpjCsllConfiguration':
    'Configuração do IRPJ E CSLL',
  'companies.customTerms.invoice.form.field.irpjCsllConfiguration.aliquotService':
    'Alíquota IRPJ - Serviço',
  'companies.customTerms.invoice.form.field.irpjCsllConfiguration.aliquotPart':
    'Alíquota IRPJ - Peça',
  'companies.customTerms.invoice.form.field.irpjCsllConfiguration.aliquotCsll':
    'Alíquota CSLL',

  'companies.customTerms.invoice.form.field.danfe': 'Danfe',
  'companies.customTerms.invoice.form.field.danfe.CodeDisplayDanfe':
    'Código Exibir no Danfe',
  'companies.customTerms.invoice.form.field.danfe.manufacturerCode':
    'Código do Fabricante',
  'companies.customTerms.invoice.form.field.danfe.internalCode':
    'Código Interno',
  'companies.customTerms.invoice.form.field.danfe.barCode': 'Código de Barras',
  'companies.customTerms.invoice.form.field.danfe.standardNFECode':
    'Código Padrão da NF-e (ex: CFOP5120)',

  'companies.customTerms.invoice.form.field.serviceInvoice':
    'Nota Fiscal de serviço',
  'companies.customTerms.invoice.form.field.serviceInvoice.seriesService':
    'Série',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet':
    'Regime especial tributação',

  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.microEnterprise':
    'Micro Empresa Municipal',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.estimated':
    'Estimativa',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.society':
    'Sociedade de Profissionais',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.cooperative':
    'Cooperativa',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.mei':
    'MEI - Simples Nacional',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.meepp':
    'ME EPP - Simples Nacional',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.yes':
    'Sim',
  'companies.customTerms.invoice.form.field.serviceInvoice.specialDiet.no':
    'Não',
  'companies.customTerms.invoice.form.field.serviceInvoice.municipalCode':
    'Código tributação municipal',
  'companies.customTerms.invoice.form.field.serviceInvoice.ServiceCode':
    'Código lista serviço',
  'companies.customTerms.invoice.form.field.serviceInvoice.ISSWithholding':
    'Retenção ISS',
  'companies.customTerms.invoice.form.field.serviceInvoice.deductISS':
    'Deduzir ISS',
  'companies.customTerms.invoice.form.field.serviceInvoice.pisCofins':
    'Retenção PIS/COFINS',
  'companies.customTerms.invoice.form.field.serviceInvoice.culturalIncentive':
    'Incentivo Cultural',
  'companies.customTerms.invoice.form.field.serviceInvoice.taxPercentage':
    'Percentual de Tributos',
  'companies.customTerms.invoice.form.field.serviceInvoice.aliquotISSQN':
    'Alíquota ISSQN padrão',
  'companies.customTerms.invoice.form.field.serviceInvoice.issuanceNFSe':
    'Sistema Emissão NFS-e*',

  'companies.customTerms.invoice.form.field.additionalData': 'Dados Adicionais',
  'companies.customTerms.invoice.form.field.additionalData.NFeSale':
    'Dados adicionais NF-e venda',
  'companies.customTerms.invoice.form.field.additionalData.NFeService':
    'Dados adicionais NF-e serviço',
  'companies.customTerms.invoice.form.field.additionalData.NFeDevolution':
    'Dados adicionais NF-e devolução',
  'companies.customTerms.invoice.form.field.additionalData.NFeEmail':
    'Dados adicionais NF-e email',

  'companies.customTerms.invoice.form.field.authorizationDownloadXml':
    'Autorização para baixar xml',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.add':
    'Adicionar',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal':
    'Informe os Dados Autorização',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.cpfCnpj':
    'Cpf/Cnpj',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.physicalPerson':
    'Pessoa Física',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.legalPerson':
    'Pessoa Jurídica',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.email':
    'Email',
  'companies.customTerms.invoice.form.field.authorizationDownloadXml.modal.action':
    'Ações',

  'companies.customTerms.invoice.form.field.settingsIcms':
    'Configuração de ICMS padrão',
  'companies.customTerms.invoice.form.field.settingsIcms.csosn': 'CSOSN',
  'companies.customTerms.invoice.form.field.settingsIcms.cstIcms': 'CST ICMS',

  'companies.customTerms.invoice.form.field.settingsIpi':
    'Configuração de IPI padrão',
  'companies.customTerms.invoice.form.field.settingsIpi.framingCode':
    'Cód. Enquadramento',
  'companies.customTerms.invoice.form.field.settingsIpi.cstIpi': 'CST IPI',
  'companies.customTerms.invoice.form.field.settingsIpi.aliquotIpi':
    'Alíquota IPI',

  'companies.customTerms.invoice.form.field.settingsPis':
    'Configuração de PIS padrão',
  'companies.customTerms.invoice.form.field.settingsPis.cstPis': 'CST PIS',
  'companies.customTerms.invoice.form.field.settingsPis.aliquotPis':
    'Alíquota PIS',

  'companies.customTerms.invoice.form.field.settingsCofins':
    'Configuração de COFINS padrão',
  'companies.customTerms.invoice.form.field.settingsPis.cstCofins':
    'CST COFINS',
  'companies.customTerms.invoice.form.field.settingsPis.aliquotCofins':
    'Alíquota COFINS',

  'companies.create.notifications.success.title': 'Sucesso',
  'companies.create.notifications.success.description':
    'Configuração de Nota Fiscal criada.',
  'companies.create.notifications.success.description.edit':
    'Configuração de Nota Fiscal editada.',
  'companies.status.message.success': 'Status da Empresa alterado com sucesso!',

  'companies.document.xml.notifications.remove.confirm.title':
    'Remover autorização.',
  'companies.document.xml.notifications.remove.confirm.content':
    'Deseja realmente remover a autorização para baixar XML selecionada?',

  'companies.document.xml.notifications.success.title': 'Sucesso',
  'companies.create.document.xml.notifications.success.description':
    'Autorização para baixar xml criada.',
  'companies.delete.document.xml.notifications.success.description':
    'Autorização para baixar xml deletada.',
  'companies.update.document.xml.notifications.success.description':
    'Autorização para baixar xml atualizada.',

  'companies.sintegra.structure': 'Cód. Identificação Estrutura Sintegra',
  'companies.sintegra.structure.icms30':
    '1 - Estrutura conforme Convênio ICMS 57/95, na versão estabelecida pelo Convênio ICMS 31/99 e com as alterações promovidas até o Convênio ICMS 30/02.',
  'companies.sintegra.structure.icms142':
    '2 - Estrutura conforme Convênio ICMS 57/95, na versão estabelecida pelo Convênio ICMS 69/02 e com as alterações promovidas pelo Convênio ICMS 142/02.',
  'companies.sintegra.structure.icms76':
    '3 - Estrutura conforme Convênio ICMS 57/95, com as alterações promovidas pelo Convênio ICMS 76/03.',
  'companies.sintegra.nature': 'Cód. Identificação Natureza Sintegra',
  'companies.sintegra.nature.interstatesSubstitution':
    '1 - Interestaduais somente operações sujeitas ao regime de Substituição Tributária',
  'companies.sintegra.nature.interstatesWithout':
    '2 - Interestaduais - operações com ou sem Substituição Tributária',
  'companies.sintegra.nature.allOperations':
    '3 - Totalidade das operações do informante',
  'companies.sintegra.name': 'Nome',
  'companies.sintegra.telephone': 'Telefone',
  'companies.sintegra.record51': 'Gerar registro Tipo 51',
  'companies.sintegra.record53': 'Gerar registro Tipo 53',

  'companies.Report.form.administrativeReport': 'Relatório Administrativo',
  'companies.Report.form.workshopReport': 'Relatório Oficina',
  'companies.Report.form.quoteMapReport': 'Relatório Mapa de cotação',
  'companies.Report.form.administrativeReport.a4': 'Padrão A4 297 x 210 mm',
  'companies.Report.form.administrativeReport.continuousForm':
    'Formulário Contínuo 210 x 280 mm',
  'companies.Report.form.administrativeReport.thermal':
    'Impressora térmica 80mm',
  'companies.Report.form.administrativeReport.58.thermal':
    'Impressora térmica 58mm',

  'companies.Report.form.check.DisplayNoteReport':
    'Exibir observação no relatório',
  'companies.Report.form.check.ShowEngine': 'Exibir motorização',

  'companies.Report.form.radio.title':
    'Nome padrão a ser exibido nos relatórios',
  'companies.Report.form.radio.corporateReason': 'Razão Social',
  'companies.Report.form.radio.fantasyName': 'Nome Fantasia',
};
